module.exports = __webpack_public_path__ + "img/loading_fff.aac54de2.gif";